<button
  [attr.type]="type()"
  [disabled]="disabled()"
  (click)="clicked.emit($event)"
  [ngClass]="size()"
>
  <mcg-icon
    *ngIf="prefixIconName()"
    [name]="prefixIconName()"
    [size]="iconSize()"
  ></mcg-icon>

  {{ label() }}

  <mcg-icon
    *ngIf="suffixIconName()"
    [name]="suffixIconName()"
    [size]="iconSize()"
  ></mcg-icon>
</button>
